import React, { FC } from 'react';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';

type WhitelabelLogoProps = {
    logo: string;
};
const WhitelabelLogo: FC<WhitelabelLogoProps> = ({ logo }: WhitelabelLogoProps) => {
    return (
        <Box display="flex" width="100%" alignItems="center">
            <Link to="/orders/list" data-test="denthub-logo-link">
                <img
                    style={{
                        height: 30,
                        marginRight: 10,
                    }}
                    src={logo}
                />
            </Link>
        </Box>
    );
};

export default WhitelabelLogo;
